export default {
    CI: process.env.REACT_APP_CI,
    folders_endpoint: 'https://thawing-shore-93226.herokuapp.com/api/folders',
    notes_endpoint: 'https://thawing-shore-93226.herokuapp.com/api/notes',
}